import { Button, SmartLink, XStack } from '@my/ui'
import { SectionTitle } from 'app/components'

export const BrandTabsHeading = ({ heading, viewAllLink }) => {
  if (!heading && !viewAllLink) return <></>
  return (
    <XStack alignItems="center" justifyContent="space-between" gap="$3.5">
      {heading && <SectionTitle flex={1}>{heading}</SectionTitle>}
      {viewAllLink && (
        <SmartLink href="/brands" Component={Button} theme="gray" size="$3" fontWeight="500">
          View All
        </SmartLink>
      )}
    </XStack>
  )
}
